import { API_BASE_URL } from '../config/serverApiConfig';
import { api } from './api';
import { runWrite, WriteResult } from './nodeWrite';

export type DelegableSetting = 'smtp' | 'connectors' | 'sla_risk' | 'roles' | 'users';

export interface ManagedBy {
  kind: string;
  id?: number;
  name?: string;
}

export interface EntityDelegation {
  id: number;
  name: string;
  delegated: Record<string, boolean>;
  has_values: Record<string, boolean>;
  source: Record<string, string | null>;
}

export interface Delegations {
  settings: DelegableSetting[];
  entities: EntityDelegation[];
}

export interface NodeSetting {
  owner: 'self' | ManagedBy;
  delegated: boolean;
  editable: boolean;
}

export const listDelegations = async (orgId: number): Promise<Delegations> => {
  const response = await api().get(`${API_BASE_URL}r/v2/organisations/${orgId}/delegations`, {
    cache: false
  } as any);
  return response.data;
};

export const grantDelegation = (
  orgId: number,
  entityId: number,
  setting: DelegableSetting
): Promise<WriteResult<void>> =>
  runWrite(() =>
    api().put(`${API_BASE_URL}r/v2/organisations/${orgId}/delegations/${entityId}/${setting}`)
  );

export const revokeDelegation = (
  orgId: number,
  entityId: number,
  setting: DelegableSetting
): Promise<WriteResult<void>> =>
  runWrite(() =>
    api().delete(`${API_BASE_URL}r/v2/organisations/${orgId}/delegations/${entityId}/${setting}`)
  );

export const nodeSettings = async (nodeId: number): Promise<Record<string, NodeSetting>> => {
  const response = await api().get(`${API_BASE_URL}r/v2/nodes/${nodeId}/settings`, {
    cache: false
  } as any);
  return response.data;
};

/** The managed_by pointer of a SETTING_MANAGED_ELSEWHERE 409, or null for any other error. */
export const managedByFrom409 = (error: any): ManagedBy | null => {
  const detail = error?.response?.data?.detail;
  if (error?.response?.status !== 409 || detail?.code !== 'SETTING_MANAGED_ELSEWHERE') return null;
  return detail.managed_by ?? { kind: 'organisation' };
};
